import { DestroyRef, inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { GetPreferencesQuery, GetPreferencesGQL } from './graphql/preferences.query.sitos-x-api.g';
import { DefaultUnitGQL } from './graphql/getDefaultUnit.sitos-x-api.g';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
    providedIn: 'root'
})
export class PrimaryColorService {

    private readonly destroyRef = inject(DestroyRef);

    private primaryColorSubject = new BehaviorSubject<string | null>(null);
    primaryColorObservable$: Observable<string | null> = this.primaryColorSubject.asObservable();
    moduleName = 'DESIGN';
    primaryColorPreferenceKey = 'PRIMARY_COLOR';
    private defaultColor = '#5761ee';

    constructor(
        private getPreferencesGQL: GetPreferencesGQL,
        private getDefaultUnitGQL: DefaultUnitGQL
    ) {
        this.primaryColorObservable$ = this.fetchPrimaryColor();
        
    }

    private fetchPrimaryColor(): Observable<string | null> {
        return this.getDefaultUnitGQL.watch({ }, { context: { client: 'sitosxapi' } }).valueChanges.pipe(
            takeUntilDestroyed(this.destroyRef),
            map(response => this.extractPrimaryColorFromUnit(response)),
                switchMap((color: any) => {

                  //console.warn('fetchPrimaryColor, color=', color);

                    if (color) {
                        return of(color);
                    }
                    return this.getPreferencesGQL.fetch({ moduleName: this.moduleName }, { context: { client: 'sitosxapi' } }).pipe(
                        map(response => 
                            response?.data?.modulePreferences?.modulePreferences?.find(
                                preference => preference?.key === this.primaryColorPreferenceKey
                            )?.value ?? this.defaultColor
                        )
                    );
                }),
                catchError(() => of(this.defaultColor)), // Default color on error
                map((color: string | null) => {
                    
                    //console.warn('fetchPrimaryColor (2), color=', color);
                    
                    this.primaryColorSubject.next(color); // Update subject with fetched color
                    return color;
                })
        );
    }

    private extractPrimaryColorFromUnit(response: any): string | null {
        return response.data.units?.defaultUnit?.color ?? null;
    }

    updateColor(currentColor: string) {
        this.primaryColorSubject.next(currentColor);
    }
}